import { BookmarkablePage, FullPagePanel, MessageType, PanelMessage, useNavigation } from "o4a-react";
import * as React from "react";
import { useLocation } from "react-router-dom";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { FilterState, FilterStateContext } from "../../console/FilterContext";
import { MCVCN_LIST_ROUTE, PageId, PageRegistrationConfig } from "../../constants/pluginConstants";
import { SvgIconIds } from "../../constants/uiConstants";
import { RoleBasedAction } from "../../helpers/roleHelper";
import { useRoles } from "../../hooks/useRoles";
import { McvcnList } from "./McvcnList";

const registrationIds = PageRegistrationConfig[PageId.MCVCN_LIST].map(config => config.key);

export const McvcnListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);
  const { pathname } = useLocation();
  const filterState = React.useContext<FilterState>(FilterStateContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isActionAllowed, actionRequiredRoles } = useRoles();
  const disableList = false; // !isActionAllowed(RoleBasedAction.LIST_MCVCN);
  const requiredRole = actionRequiredRoles(RoleBasedAction.LIST_MCVCN)[0]?.displayName;

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(MCVCN_LIST_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (filterState.pillFilterStateValue.listId !== pathname) {
      filterState.setFilterStateValue({ filterValues: undefined, listId: undefined, defaultPills: undefined });
      filterState.setFilterTextValue(undefined);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listMcvcn.titles.short()}
    >
      <FullPagePanel
        title={Messages.listMcvcn.titles.long()}
        icon={SvgIconIds.networkSvg}
        message={disableList
          ? {
            type: MessageType.WARNING,
            text: Messages.validation.roleMissingForList(requiredRole),
          } as PanelMessage
          : undefined}
        onClose={back}
        isOpen
      >
        <McvcnList disabled={disableList} />
      </FullPagePanel>
    </BookmarkablePage>
  );
};
